import { supabase } from 'src/services/supabase-client';
import { Note } from '../types/note';

export const getNote = async (id: string): Promise<Note> => {
  const response = (
    await supabase
      .from<Note>('notes')
      .select('id,title,body,order')
      .eq('id', id)
      .limit(1)
      .single()
  ).data;

  if (!response) throw Error(`Note with id: ${id} was not found`);

  return response;
};
